import React, { useState, useEffect } from 'react';
import { BentoGrid } from './BentoGrid';

/**
 * Section 3 - Features Section
 * Displays the feature grid showcasing new capabilities
 */
export function FeaturesSection({ backgroundColor }) {
  const allTestimonials = [
    {
      name: 'Valentin H.',
      text: 'Endlich ein Radio, das mich wirklich versteht! Die PKI-Funktion ist genial.',
      rating: 5
    },
    {
      name: 'Robert G.',
      text: 'Die Moderationen von Chris & Lena sind so natürlich, ich vergesse manchmal dass es KI ist!',
      rating: 4
    },
    {
      name: 'Josias F.',
      text: 'Mein neuer Lieblingssender für den Arbeitsalltag. Die Musikauswahl ist perfekt.',
      rating: 5
    },
    {
      name: 'Claudius C.',
      text: 'schmalgsicht v2 ist ein riesiger Sprung nach vorne. Die Interaktionsmöglichkeiten sind top!',
      rating: 4
    },
    {
      name: 'Christof W.',
      text: 'Perfekt für lange Coding-Sessions. Die Musik passt immer zu meiner Stimmung.',
      rating: 5
    },
    {
      name: 'Lena L.',
      text: 'Ich liebe es, dass ich meine Lieblingssongs wünschen kann. Fühlt sich an wie echtes Radio!',
      rating: 4
    },
    {
      name: 'Franz B.',
      text: 'Die stündlichen Nachrichten halten mich auf dem Laufenden. Genau das hat mir gefehlt!',
      rating: 5
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 3) % allTestimonials.length);
    }, 15000); // Wechselt alle 15 Sekunden

    return () => clearInterval(interval);
  }, [allTestimonials.length]);

  // Get 3 testimonials starting from currentIndex, wrapping around
  const getVisibleTestimonials = () => {
    const result = [];
    for (let i = 0; i < 3; i++) {
      result.push(allTestimonials[(currentIndex + i) % allTestimonials.length]);
    }
    return result;
  };

  const testimonials = getVisibleTestimonials();

  return (
    <div
      id="features"
      className="min-h-screen flex items-center justify-center w-full relative pointer-events-none px-4 sm:px-8 md:px-16 lg:px-24"
      style={{
        scrollSnapAlign: 'start',
        scrollSnapStop: 'always',
        overflow: 'hidden',
        maxWidth: '100vw'
      }}
    >
      <div className="max-w-7xl w-full text-center">
        {/* Section Heading */}
        <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-center mb-8 sm:mb-12 text-white">
          Wir haben nicht nur <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500">geredet</span> – wir haben <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500">geliefert</span>
        </h2>

        <div className="w-full pointer-events-auto">
          <BentoGrid />

          {/* Testimonials */}
          <div className="mt-16 sm:mt-20">
            <div className="flex items-center gap-4 mb-8">
              <div className="h-px flex-1 bg-gradient-to-r from-transparent via-gray-700 to-transparent"></div>
              <span className="text-white text-2xl sm:text-3xl md:text-4xl font-bold">Was unsere Hörer sagen</span>
              <div className="h-px flex-1 bg-gradient-to-r from-transparent via-gray-700 to-transparent"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {testimonials.map((testimonial, index) => {
                // 3 colors matching "Über uns" section
                const colorStyles = [
                  { bg: 'bg-white', text: 'text-gray-900', subtext: 'text-gray-700', avatar: 'bg-gradient-to-r from-blue-500 to-pink-500' },
                  { bg: 'bg-gradient-to-br from-pink-500 to-purple-600', text: 'text-white', subtext: 'text-white/90', avatar: 'bg-white/20' },
                  { bg: 'bg-blue-500', text: 'text-white', subtext: 'text-white/90', avatar: 'bg-white/20' },
                ];
                const style = colorStyles[index % 3];

                return (
                  <div
                    key={`${currentIndex}-${index}`}
                    className={`${style.bg} rounded-2xl p-5 sm:p-6 text-left transition-opacity duration-500 flex flex-col h-full`}
                  >
                    <p className={`${style.subtext} text-sm sm:text-base leading-relaxed mb-4 flex-grow`}>
                      "{testimonial.text}"
                    </p>
                    <div className="flex items-center gap-3 mt-auto">
                      <div className={`w-8 h-8 rounded-full ${style.avatar} flex items-center justify-center`}>
                        <span className={`font-bold text-xs ${index === 0 ? 'text-white' : 'text-white'}`}>
                          {testimonial.name.charAt(0)}
                        </span>
                      </div>
                      <p className={`font-medium ${style.text} text-sm`}>{testimonial.name}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
